const methodLabels = { cash: 'Cash', mobile_money: 'Mobile Money', bank_transfer: 'Bank Transfer', card: 'Card' }

export default function RecentPayments({ subscriptions, settings }) {
  const currency = settings.currency || 'ZMW'
  const recent = subscriptions.slice(0, 10)

  return (
    <div className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10">
      <div className="px-4 sm:px-6 py-4 border-b border-gray-200 dark:border-white/10">
        <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold">Recent Payments</div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-black/20">
              {['Member', 'Chapter', 'Amount', 'Method', 'Reference', 'Date'].map((h) => (
                <th key={h} className="text-left py-3 px-4 text-xs text-gray-500 uppercase tracking-widest font-semibold whitespace-nowrap">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {recent.length === 0 ? (
              <tr>
                <td colSpan="6" className="py-8 px-4 text-center text-gray-400 text-sm">No payments recorded yet</td>
              </tr>
            ) : (
              recent.map((sub) => (
                <tr key={sub.id} className="border-b border-gray-200 dark:border-white/5 hover:bg-gray-50 dark:hover:bg-white/5 transition-colors">
                  <td className="py-3 px-4 font-semibold whitespace-nowrap text-gray-900 dark:text-white">{sub.supporters?.full_name || '—'}</td>
                  <td className="py-3 px-4 text-gray-500 text-xs whitespace-nowrap">{sub.supporters?.chapters?.name || '—'}</td>
                  <td className="py-3 px-4 text-green-600 dark:text-green-400 font-bold whitespace-nowrap">{currency} {Number(sub.amount).toLocaleString()}</td>
                  <td className="py-3 px-4 text-gray-500 text-xs whitespace-nowrap">{methodLabels[sub.payment_method] || sub.payment_method}</td>
                  <td className="py-3 px-4 text-gray-500 text-xs font-mono whitespace-nowrap">{sub.transaction_ref || '—'}</td>
                  <td className="py-3 px-4 text-gray-500 text-xs whitespace-nowrap">
                    {new Date(sub.payment_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}